


































































import { Interactive_Addon_CardType_Config } from '@tt4b/ttam-enums';
import { computed, defineComponent, toRefs, ref } from '@vue/composition-api';
import TtamInteractiveAddOnUpdateMenu from './interactive-add-on-update-menu.vue';
import { deleteAddOnClick, addOnDeleteConfirm, addOnDeleteCancel } from './../../../../track/edit-event';

const name = 'ttam-interactive-add-on-editor';
export default defineComponent({
  components: {
    TtamInteractiveAddOnUpdateMenu,
  },
  props: {
    cardType: {
      type: Number,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isAddonDeleteBtnDisabled: {
      type: Boolean,
      default: false,
    },
    isAddonEditBtnHide: {
      type: Boolean,
      required: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { cardType, isEdit } = toRefs(props);
    const deleteAddonDialogVisible = ref(false);
    const onClick = () => {
      emit('openDrawer');
    };
    const showDialog = () => {
      deleteAddonDialogVisible.value = true;
      isEdit.value && deleteAddOnClick();
    };
    const handleCancel = () => {
      deleteAddonDialogVisible.value = false;
      isEdit.value && addOnDeleteCancel();
    };
    const handleDelete = () => {
      deleteAddonDialogVisible.value = false;
      isEdit.value && addOnDeleteConfirm();
      emit('delete-add-on');
    };
    const cardTypeName = computed(() => Interactive_Addon_CardType_Config[cardType.value]?.i18nName ?? '');
    return {
      name,
      deleteAddonDialogVisible,
      cardTypeName,
      showDialog,
      onClick,
      handleCancel,
      handleDelete,
    };
  },
});
